import dnsStore from 'relapp-dns/src/store/dns';

export default dnsStore;
